import React, { useEffect, useRef, useState } from "react"

export default ({
  text = "A long title \n on two lines",
  color = "green",
  extraSpaceIfSmall = true,
  fontSize = 12,
  gradient = false,
}) => {
  let textArray = text.split("\n")

  const svgEl = useRef()
  const textEl = useRef([])

  const customClass = ` animate-fadeIn [font-family:MonumentExtended;] [font-size:${fontSize}px;] [text-transform:uppercase;] tracking-tighter`

  let fillColor = color === "grey" ? "#E7EFF8" : "#52F597"

  useEffect(() => {
    function handleResize(initial = false) {
      var svg = svgEl.current
      if (!textEl.current || !textEl.current[0]) {
        // When you resize the page, open developer tools or something don't execute a resize
        // because it's not working properly
        return
      }
      let minBBox = textEl.current[0].getBBox()
      if (textEl.current.length > 1) {
        textEl.current.forEach((el, idx) => {
          var bbox = el.getBBox()
          minBBox.width = Math.max(minBBox.width, bbox.width)
          minBBox.height =
            idx === 0
              ? minBBox.height
              : idx === textEl.current.length - 1
              ? minBBox.height + bbox.height
              : minBBox.height + bbox.height
          el.setAttribute(
            "y",
            minBBox.y - (minBBox.y * (idx + 1) + (initial ? 1 : 0))
          )
        })
        svg.setAttribute(
          "viewBox",
          [minBBox.x, minBBox.y, minBBox.width, minBBox.height].join(" ")
        )
      } else {
        var bbox = textEl.current[0].getBBox()
        minBBox.width = Math.max(minBBox.width, bbox.width)

        textEl.current[0].setAttribute("y", 0)

        svg.setAttribute(
          "viewBox",
          [minBBox.x, -9.5, minBBox.width, 10].join(" ")
        )
      }
    }
    window.addEventListener("resize", () => handleResize(false))
    window.addEventListener("load", () => handleResize(true))

    //storybook hack
    const timerId = setTimeout(() => handleResize(false), 500)

    // unsubscribe from event and timers to avoid memory likage
    return () => {
      window.removeEventListener("resize", () => handleResize(false))
      window.removeEventListener("load", () => handleResize(true))
      if (timerId) {
        clearTimeout(timerId)
      }
    }
  }, [])

  return (
    <>
      {" "}
      <svg
        ref={svgEl}
        style={{ display: "block", width: "100%", maxHeight: "100%" }}
      >
        <defs>
          <linearGradient id="customGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="rgba(255, 255, 255, 0.70)" />
            <stop offset="100%" stopColor="rgba(255, 255, 255, 0.00)" />
          </linearGradient>
        </defs>
        {textArray.map((line, idx) => {
          return line.length > 3 || extraSpaceIfSmall === false ? (
            <text
              key={idx}
              ref={el => (textEl.current[idx] = el)}
              className={customClass}
              fill={gradient ? "url(#customGradient)" : fillColor}
            >
              {line}
            </text>
          ) : (
            <text
              key={idx}
              ref={el => (textEl.current[idx] = el)}
              className={customClass}
              fill={gradient ? "url(#customGradient)" : fillColor}
              x="0"
              dy={`${idx * 1.2}em`}
            >
              {line} &nbsp;
            </text>
          )
        })}
      </svg>
    </>
  )
}